import { Injectable } from '@angular/core';
import { ENUM_ROLES } from '@module-role/enums/enum-roles';
import { ActionSetDropDownRolesDisabled } from '@module-shared/actions/actions-roles-disable';
import { ActionSetDropDownRolesEnabled } from '@module-shared/actions/actions-roles-enable';
import { Action, State, StateContext } from '@ngxs/store';
import { Values } from '@utils-global/type-values';

export interface StateRolesDropdown {
  readonly disabledItems: Values<typeof ENUM_ROLES>[];
}

@State<StateRolesDropdown>({
  name: 'StateRolesDropdown',
  defaults: {
    disabledItems: []
  }
})
@Injectable()
export class StateRolesDropdownService {
  @Action(ActionSetDropDownRolesDisabled)
  provideDisabled(
    ctx: StateContext<StateRolesDropdown>,
    action: ActionSetDropDownRolesDisabled
  ) {
    ctx.patchState({
      ...ctx.getState(),
      ...{ disabledItems: action.roles }
    });
  }

  @Action(ActionSetDropDownRolesEnabled)
  provideEnabled(
    ctx: StateContext<StateRolesDropdown>,
    action: ActionSetDropDownRolesEnabled
  ) {
    ctx.patchState({
      ...ctx.getState(),
      ...{
        disabledItems: Object.values(ENUM_ROLES).filter(
          (x) => !action.roles.includes(x)
        )
      }
    });
  }
}
